import React, { ReactElement } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faSpinner)

const Loading = (props: { message?: string }): ReactElement =>
    <div className="loading" role="status" aria-busy="true">
        <FontAwesomeIcon icon="spinner" spin />
        {props.message && <h3>{props.message}</h3>}
    </div>

export default Loading
